



















import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import Select from '@/components/utils/Select.vue';
import Button from '@/components/utils/Button.vue';

@Component({
  components: {
    Button,
    Select,
  },
})
export default class Thumbnail extends Vue {
  @Prop({ type: String, required: true })
  readonly type!: string;

  @Prop({ type: Boolean, required: true })
  readonly hasSelect!: boolean;

  @Prop({ type: Number, required: true })
  readonly value!: Number;

  yearForced: string = '';

  yearValue: string = '';

  get compTitle(): string {
    switch (this.type) {
      case 'enfants':
        return `Nombre d'${this.type} en moyenne par ligne`;
      case 'lignes':
        return `Nombre de ${this.type} créées`;
      case 'comptes':
        return `Nombre de ${this.type} créés`;
      default:
        return '';
    }
  }

  get compBackgroundColor(): string {
    switch (this.type) {
      case 'enfants':
        return 'thumbnail-background-kids';
      case 'lignes':
        return 'thumbnail-background-lines';
      case 'comptes':
        return 'thumbnail-background-account';
      default:
        return '';
    }
  }

  get compCurMonth(): string {
    return this.compMonth[new Date(Date.now()).getMonth()];
  }

  get compMonth(): Array<string> {
    return ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  }

  get compCurYear(): string {
    return new Date(Date.now()).getFullYear().toString();
  }

  get compYear(): Array<Number> {
    const year = new Date(Date.now()).getFullYear();
    const startingYear = 1970;
    return [...Array(year - (startingYear - 1)).keys()].map((v: number) => v + startingYear).sort((a, b) => b - a);
  }

  @Emit('monthSelected')
  monthSelected(val: any): void {
    console.log(val, this.yearValue);
    if (this.yearValue === '' && val !== '') {
      console.log('Forced year');
      this.yearForced = new Date(Date.now()).getFullYear().toString();
    }
  }

  @Emit('yearSelected')
  yearSelected(val: any): void {
    this.yearValue = val;
  }

  onDetailClicked(): void {
    this.$router.push({ path: '/lines/details' });
  }
}
